import { Route } from '@angular/router';
import {
  CompiledDashboardComponent,
  provideCompiling,
} from '@sportello-balneari/forms-engine';
import { initialDataResolver } from './app.resolvers';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
import { RoleGuard } from './core/auth/guards/role.guard';
import { LayoutComponent } from './layout/layout.component';
import { NewModuleComponent } from './modules/user/tenders/new-module/new-module.component';

// @formatter:off

export const appRoutes: Route[] = [
  // Redirect empty path to '/example'
  { path: '', pathMatch: 'full', redirectTo: 'tenders' },

  // Redirect signed-in user to the '/example'
  //
  // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
  // path. Below is another redirection for that path to redirect the user to the desired
  // location. This is a small convenience to keep all main routes together here on this file.
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'tenders' },

  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'confirmation-required',
        loadChildren: () =>
          import('./modules/auth/confirmation-required/confirmation-required.routes'),
      },
      // {
      //   path: 'confirm-password',
      //   loadChildren: () =>
      //     import('./modules/auth/confirm-password/confirm-password.routes'),
      // },
      {
        path: 'set-password',
        loadChildren: () =>
          import('./modules/auth/set-password/set-password.routes'),
      },
      {
        path: 'forgot-password',
        loadChildren: () =>
          import('./modules/auth/forgot-password/forgot-password.routes'),
      },
      {
        path: 'reset-password',
        loadChildren: () =>
          import('./modules/auth/reset-password/reset-password.routes'),
      },
      {
        path: 'sign-in',
        loadChildren: () => import('./modules/auth/sign-in/sign-in.routes'),
      },
      {
        path: 'sign-up',
        loadChildren: () => import('./modules/auth/sign-up/sign-up.routes'),
      },
    ],
  },

  // Auth routes for authenticated users
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'sign-out',
        loadChildren: () => import('./modules/auth/sign-out/sign-out.routes'),
      },
      {
        path: 'unlock-session',
        loadChildren: () =>
          import('./modules/auth/unlock-session/unlock-session.routes'),
      },
    ],
  },

  // Landing routes
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'home',
        loadChildren: () => import('./modules/landing/home/home.routes'),
      },
    ],
  },
  // Admin routes
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: 'tenders',
        loadChildren: () => import('./modules/user/tenders/tenders.routes'),
      },
      {
        path: 'reports',
        loadChildren: () => import('./modules/user/reports/reports.routes'),
      },
      // {
      //   path: 'monitors',
      //   loadChildren: () => import('./modules/user/monitors/monitors.routes'),
      // },
      {
        path: 'users',
        canActivate: [RoleGuard],
        canActivateChild: [RoleGuard],
        data: { requiredRoles: ['Admin'] },
        loadChildren: () => import('./modules/admin/users/users.routes'),
      },
      {
        path: 'bots',
        canActivate: [RoleGuard],
        canActivateChild: [RoleGuard],
        data: { requiredRoles: ['Admin'] },
        loadChildren: () => import('./modules/admin/bots/bots.routes'),
      },
      {
        path: 'business-owners',
        loadChildren: () =>
          import('./modules/admin/business-owners/business-owners.routes'),
      },
      {
        path: 'crm',
        canActivate: [RoleGuard],
        canActivateChild: [RoleGuard],
        data: { requiredRoles: ['Admin', 'Crm'] },
        loadChildren: () => import('./modules/admin/crm/crm.routes'),
      },
      {
        path: 'new-module',
        component: NewModuleComponent,
      },
      {
        path: 'compiled-dashboard',
        component: CompiledDashboardComponent,
        providers: [...provideCompiling()],
      },
    ],
  },

  { path: '**', redirectTo: 'tenders' },
];
